<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" :isShowMore="true" />
    <pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights">

         <li v-if='rights("ExportToExcel")' class="nav-system" :title='$rs["pager_export_excel"]'>
          <a @click.stop='exportToExcel'><span class="glyphicon glyphicon-export"></span></a>
      </li>
      <!--li class="nav-system" :title='rs["downloadTitle"]'><a @click.stop='download'>{{rs["download"]}}</a></li-->
      <li v-if='rights("CreateAtt")' class="nav-system" :title='rs["createTitle"]'><a @click.stop='showGN'>{{rs["create"]}}</a></li>
      <li v-if='rights("DeleteAtt")' class="nav-system" :title='rs["deleteRcTitle"]'><a @click.stop='deleteRc'>{{rs["deleteRc"]}}</a></li>
      <li v-if="false" class="nav-system" :title='rs["fillCardTitle"]'><a @click.stop='showFC'>{{rs["fillCard"]}}</a></li>
      <li v-if='rights("AuditingAtt")' class="nav-system" :title='rs["lockTitle"]'><a @click.stop='lock'>{{rs["lock"]}}</a></li>
      <li v-if='rights("CancelAuditingAtt")' class="nav-system" :title='rs["cancelLockTitle"]'><a @click.stop='unlock'>{{rs["cancelLock"]}}</a></li>
      <li v-if='false' class="nav-system" :title='rs["DealWithAttTitle"]'><a @click.stop='DealWithAtt'>{{rs["DealWithAtt"]}}</a></li>
      <li><a @click.stop='DealWithAtt'>{{rs["DealWithAtt"]}}</a></li>
    </pager-panel><list-panel @updateIdx="updateIdx" :selIdx="selIdx" @rowDbclick="rowDbclick" :config="config" :isAutoLoad='0' :rs="rs" /> 
    <keep-alive>
      <generater v-if="showGenerater" @close="closeGN" :rs="rs" :bcs="config.bc" 
                 :depts="config.dept" :url="config.url" :bdate="config.params.xdate1.data" :edate="config.params.xdate2.data" /> 
      <filler v-if="showFillCard" @close="closeFC" :rs="rs" :bcs="config.bc" :depts="config.dept" :url="config.url" />
    </keep-alive>
  <detail v-if="showDetail" @close="closeDetail" :rs="rs" :width="'700px'" :url="config.url" 
  :eidx="editIndex" :list="config.list" :empIdv="empId" :xdatev="xdate" :dkv="dk" :ndkv="ndk" 
  :sjv="sj" :txv="txx" :qtv="qt" :slistv="slist" :empNamev="empName" :config="config" />
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";
import generater from "./generater";
import filler from "./fillCard";
import detail from "./detail";

export default {
  created: function() {
    const dt = this.$dateNow();
    this.config.params.xdate1.data = dt;
    this.config.params.xdate2.data = dt;
    if (this.config.dept) {
      this.config.dept.forEach(d => {
        this.config.params.dept.options.push({ value: d.bmbh, text: d.bmmc });
      });
    }
    if (this.config.bc) {
      this.config.bc.forEach(d => {
        this.config.params.shiftNo.options.push({
          value: d.shiftNo,
          text: d.shiftName
        });
      });
    }
    if (this.config.xgroup) {
      this.config.xgroup.forEach(d => {
        this.config.params.xgroup.options.push({ value: d, text: d });
      });
    }
  },
  data() {
    return {
      config: data,
      showFillCard: false,
      showGenerater: false,
      showDetail: false,
      empId: null,
      xdate: null,
      dk: null,
      ndk: null,
      sj: null,
      txx: null,
      qt: null,
      empName: null,
      slist: [],
      editIndex: -1
    };
  },
  methods: {
    initDept(deptNo) {
      this.$getData(this.config.url + "initDept?deptNo=" + deptNo, data => {
        if (data && data.rs) {
          const arr = [];
          if (data.xgroup && data.xgroup.length > 0) {
            data.xgroup.forEach(d => {
              arr.push({ value: d, text: d });
            });
          }
          this.config.params.xgroup.options = arr;
        }
      });
    },
    download() {
      this.$getData(this.config.url + "DownloadGlog");
    },
    showGN() {
      this.showGenerater = true;
    },
    closeGN() {
      this.showGenerater = false;
      this.$loadData(this.config);
    },
    create() {},
    showFC() {
      this.showFillCard = true;
    },
    closeFC() {
      this.showFillCard = false;
    },
    fillCard() {},
    deleteRc() {
      const arr = this.getSel();
      if (arr.length <= 0) this.alertRS("selFist");
      else {
        if (this.$confirm("是否确认删除这些记录？"))
          this.$delAndReload(
            this.config.url + "Att",
            arr,
            this.config,
            this.listCallback
          );
      }
    },
    DealWithAtt() {
      const arr = this.getSel();
      if (arr.length <= 0) this.alertRS("selFist");
      else {
        const param = this.$getParamsFromList(this.config);
        //console.log(arr)
        this.$postData(
          this.config.url + "DealWithAtt",
          { Data: arr, Params: param },
          this.DealWithCallback
        );
      }
    },
    lock() {
      const arr = this.getSel();
      if (arr.length <= 0) this.alertRS("selFist");
      else {
        const param = this.$getParamsFromList(this.config);
        //console.log(arr)
        this.$postData(
          this.config.url + "lock",
          { Data: arr, Params: param },
          this.lockCallback
        );
      }
    },
    unlock() {
      const arr = this.getSel();
      if (arr.length <= 0) this.alertRS("selFist");
      else {
        const param = this.$getParamsFromList(this.config);
        this.$postData(
          this.config.url + "unlock",
          { Data: arr, Params: param },
          this.unlockCallback
        );
      }
    },
    lockCallback(rs) {
      if (rs) {
        this.$extend(this.config, rs);
        this.alertRS("ls");
      }
    },
    DealWithCallback(rs) {
      if (rs) {
        this.$extend(this.config, rs);
        this.alertRS("ls");
      }
    },
    unlockCallback(rs) {
      if (rs) {
        this.$extend(this.config, rs);
        this.alertRS("us");
      }
    },
    getSel() {
      const arr = [];
      this.getSelRows().forEach(d => {
        arr.push(d.autoid);
      });
      return arr;
    },
    rowDbclick(idx, item) {
      if (!this.rights("AddTime")) return;
      this.$getData(
        this.config.url +
          "Detail?bh=" +
          item.empId +
          "&rq=" +
          item.xdate +
          this.$urlSq(),
        data => {
          if (data.rs == 1) {
            this.empId = item.empId;
            this.empName = item.empName;
            this.xdate = this.formatter.fdate(item.xdate);
            this.dk = data.dk;
            this.ndk = data.ndk;
            this.sj = data.sj;
            this.txx = data.txx;
            this.qt = data.qt;
            this.slist = data.shiftList;
            this.showDetail = true;
            this.editIndex = idx;
          }
        }
      );
    },
    closeDetail() {
      this.showDetail = false;
    }
  },
  mixins: [mixin.list],
  components: {
    generater,
    filler,
    detail
  }
};
</script>

